import SupportFeedbackButton from './SupportFeedbackButton.component';

export default SupportFeedbackButton;
